export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn pointer",
                description : "A pointer is a variable pointing to the address of another variable. It is declared along with an asterisk symbol (*)",
                level : 'Beginner',
                lessionNumber : 1
            },
            {
                heading : "Learn loops",
                description : "In C programming, loops are used to execute a block of code repeatedly until a specified condition is met.",
                level : 'Beginner',
                lessionNumber : 4
            },
            {
                heading : "Learn recursion",
                description : "The recursion process in C refers to the process in which the program repeats a certain section of code in a similar way.",
                level : 'Beginner',
                lessionNumber : 2
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "C programming",
                description : " Learn the fundamentals of C programming, including variables, data types, functions, control structures, and DOM manipulation.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Python for Beginners",
                description : "Dive into the world of Python programming, covering syntax, data structures, control flow, functions, and file handling.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Introduction to SQL",
                description : "Learn the fundamentals of SQL, including database structures, how to write SQL queries, and how to navigate the PostgreSQL database server.",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                heading : "Operation System",
                description : "Explore the fundamentals of Operating System, covering process management, memory management, file/IO system, scheduling and deadlock.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Computer Network",
                description : "Learn the fundamentals of Computer network, including OSI layer, network topology, routing and switching, and network security.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "DBMS",
                description : "Learn the fundamentals of Database Management System, including how to design ER diagram, how to do normalization of data and indexing.",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses : [
            {
                heading : "Data Structure",
                description : "Discover the fundamentals of programming with Data Structure. Learn various data structure like arrays, strings , linked-list, stack, queue and tree etc.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Algorithm",
                description : "Learn the fundamentals of algorithm which includes Time and space complexity, searching and sorting and many more .",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "AI",
                description : "Learn the fundamentals of AI, for building different AI tools and solve complex problems.",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'Career paths',
        courses : [
            {
                heading : "DSA",
                description : "Learn the fundamentals of DSA, a DSA helps to increase the problem solving ability.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Data Scientist",
                description : "Learn the fundamentals of data science, including python, jypiter, libraries, and many more in a hands-on approach",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "ML Engineer",
                description : "Learn the fundamentals of ML, a headless for structured content that can be delivered through any channel.",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
]